import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { type ParcelLabResponse } from './ParcelLabTypes'

export const parcelLabAccessorGetParcelLabDeliveredStatus = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
  parcelLabData?: ParcelLabResponse,
): boolean => {
  const isParcelLabStatusDelivered =
    parcelLabData?.header[0]?.last_delivery_status.status === 'Delivered'

  const isOrderDelivered = subOrder.status === 'delivered'

  return isParcelLabStatusDelivered || isOrderDelivered
}
